import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { FeatureClaimComponent } from "./containers/feature-claim/feature-claim.component";

const routes: Routes = [
  {
    path: "",
    component: FeatureClaimComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FeatureRoutingModule {}
